import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { AppointmentIframeModal } from 'components/modals/appointment-iframe-modal.component';
import { useBookingModalVisibility } from 'hooks/use-booking-modal-visibility/use-booking-modal-visibility.hook';
import { useBookingExitRouting } from 'hooks/use-booking-exit-routing/use-booking-exit-routing.hook';

/**
 * Renders the booking iframe modal when there is a valid HTTPS `bookingLink`
 * from router state (masonry action) or from tab {@link sessionStorage} for the
 * same route (survives refresh). Visibility/state is owned by
 * {@link useBookingModalVisibility} and exit routing by
 * {@link useBookingExitRouting}.
 */
const BookAppointmentModalOpenShell = ({
  bookingLink,
  onClose,
}: {
  bookingLink: string;
  onClose: (hasCompleted: boolean) => void;
}) => {
  const { formatMessage } = useIntl();

  usePageViewAnalytics({ screen_name: 'Book Appointment' });
  useDocumentTitle(formatMessage({ id: 'STR_BOOK_APPOINTMENT' }));

  return <AppointmentIframeModal bookingLink={bookingLink} onClose={onClose} />;
};

export const BookAppointmentModalHost = () => {
  const { showBookingModal, bookingLink } = useBookingModalVisibility();
  const { handleExit } = useBookingExitRouting();

  if (!showBookingModal || bookingLink === undefined) {
    return null;
  }

  return (
    <BookAppointmentModalOpenShell
      bookingLink={bookingLink}
      onClose={handleExit}
    />
  );
};
